import { lazy, useEffect, useState } from 'react';
// project-imports
import Routes from 'routes';
import ThemeCustomization from 'themes';
import Loader from 'components/Loader';
import RTLLayout from 'components/RTLLayout';
import ScrollTop from 'components/ScrollTop';
import Snackbar from 'components/@extended/Snackbar';
import Notistack from 'components/third-party/Notistack';

import { dispatch } from 'store';
import { fetchMenu } from 'store/reducers/menu';

// auth-provider
import useIsOnline from 'hooks/useOnline';
import OfflinePage from 'pages/common/YouAreOffline';
import { DataContextProvider } from 'contexts/DataContext';
import { WebsocketContextProvider } from 'contexts/WebSocketContext';
import ErrorBoundary from 'pages/common/ErrorBoundary';
import Loadable from 'components/Loadable';
// import Customization from 'components/Customization';

const MaintenanceUnderConstruction = Loadable(lazy(() => import('pages/maintenance/under-construction/under-construction')));

const App = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const isOnline = useIsOnline();
  const serverStatus = true;
  useEffect(() => {
    dispatch(fetchMenu()).then(() => {
      setLoading(false);
    });
  }, []);

  if (loading) return <Loader />;

  return (
    <ThemeCustomization>
      <ErrorBoundary>
        <RTLLayout>
          <ScrollTop>
            {serverStatus ? (
              <>
                {isOnline ? (
                  <DataContextProvider>
                    <WebsocketContextProvider>
                      <Notistack>
                        <Routes />
                        {/* TODO: TO ENABLE CUSTOMIZATION */}
                        {/* <Customization /> */}
                        <Snackbar />
                      </Notistack>
                    </WebsocketContextProvider>
                  </DataContextProvider>
                ) : (
                  <OfflinePage />
                )}
              </>
            ) : (
              <MaintenanceUnderConstruction />
            )}
          </ScrollTop>
        </RTLLayout>
      </ErrorBoundary>
    </ThemeCustomization>
  );
};

export default App;
